module.exports = "https://static.wmbcdn.com/uniweb/images/284274dc1a6e9b7722dd06bc543efbfc.webp";